// CS Composite — shared bike-fitment matching.
//
// Fitment entries come from each product's custom.fitment metafield, one
// entry per Brand|Model|YearRange. YearRange is either "2024-2026" or "*"
// (fits regardless of year). Brand and/or Model can also be "*" — a truly
// universal part (e.g. fork guards that clamp onto any standard fork) uses
// "*|*|*" to match every brand/model/year. Both the Bike Finder (homepage)
// and the product-page fit strip read/write the same localStorage key so a
// bike picked once applies everywhere.
window.CSFitment = (function () {
  var STORAGE_KEY = 'csFitsMyBike_v2';

  function parseRange(years) {
    if (!years || years === '*') return null;
    var parts = String(years).split('-');
    var start = parseInt(parts[0], 10);
    var end = parseInt(parts[1], 10);
    if (isNaN(start) || isNaN(end)) return null;
    return { start: start, end: end };
  }

  function yearInRange(years, year) {
    var range = parseRange(years);
    if (!range) return true; // '*' or unparseable = always matches
    return year >= range.start && year <= range.end;
  }

  function entryMatches(entry, brand, model, year) {
    var brandMatches = entry.brand === '*' || entry.brand === brand;
    var modelMatches = entry.model === '*' || entry.model === model;
    return brandMatches && modelMatches && yearInRange(entry.years, year);
  }

  function productMatches(fitmentList, brand, model, year) {
    if (!fitmentList || !fitmentList.length) return false;
    for (var i = 0; i < fitmentList.length; i++) {
      if (entryMatches(fitmentList[i], brand, model, year)) return true;
    }
    return false;
  }

  function saveBike(bike) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(bike));
    } catch (e) {}
  }

  function loadBike() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var b = JSON.parse(raw);
      if (b && b.brand && b.model && b.year) return b;
    } catch (e) {}
    return null;
  }

  function clearBike() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  return {
    STORAGE_KEY: STORAGE_KEY,
    productMatches: productMatches,
    saveBike: saveBike,
    loadBike: loadBike,
    clearBike: clearBike
  };
})();
